import type { StoreActionApi } from '@atlassian/react-sweet-state';
import type { Group, GroupWithTicketTypeIds } from '../../../../common/types';
import { getGroupsSelector } from '../../selectors';
import type { ImmutableState } from '../../types';

const setTicketTypesByGroup =
	(groupRelations: GroupWithTicketTypeIds[]) =>
	({ getState, setState }: StoreActionApi<ImmutableState>) => {
		const state = getState();
		setState({
			...state,
			ticketTypesByGroup: groupRelations.reduce(
				(acc, { id, ticketTypes }) => ({
					// eslint-disable-next-line jira/js/no-reduce-accumulator-spread
					...acc,
					[id]: ticketTypes,
				}),
				// Default relations to empty array to differentiate between
				// still waiting on data and data retrieved with no results
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				getGroupsSelector(state).reduce<Record<string, any>>(
					(acc, { id }: Group) => ({
						// eslint-disable-next-line jira/js/no-reduce-accumulator-spread
						...acc,
						[id]: [],
					}),
					{},
				),
			),
		});
	};

export default setTicketTypesByGroup;
